import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const retrieveAllDogLocations = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/pets/dogs/locations/`);
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
